document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('ProductGridContainer');
  var grid = document.getElementById('product-grid');
  var sentinel = document.getElementById('infinite-scroll-sentinel');

  // NOVO: sortira sold-out proizvode na dno grida
  function pushSoldOutToBottom() {
    if (!grid) return;
    var soldOutItems = grid.querySelectorAll('[data-sold-out="true"]');
    soldOutItems.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  if (grid) pushSoldOutToBottom(); // NOVO: sortira ono što je server već renderovao na inicijalnom loadu

  if (!container || !grid || !sentinel) return;

  var currentPage = parseInt(container.dataset.currentPage || '1', 10);
  var totalPages = parseInt(container.dataset.totalPages || '1', 10);
  var loading = false;

  if (currentPage >= totalPages) return;

  var paginationNav = container.querySelector('.pagination');
  if (paginationNav) paginationNav.style.display = 'none';

  // Otkriva svaki proizvod pojedinačno, tačno kad uđe u vidno polje
  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('infinite-scroll-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  // Dovlači sledeću stranicu kad se približiš dnu
  var loadObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !loading) loadNextPage();
    });
  }, { rootMargin: '1000px' });

  loadObserver.observe(sentinel);

  function loadNextPage() {
    if (currentPage >= totalPages) {
      loadObserver.disconnect();
      return;
    }
    loading = true;
    var nextPage = currentPage + 1;
    var url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);

    fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (!newGrid) return;

        var newItems = Array.from(newGrid.children);
        newItems.forEach(function (item, index) {
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          item.removeAttribute('data-cascade');
          item.classList.add('infinite-scroll-new');
          item.style.setProperty('--animation-order', (index % 4) + 1);
          item.querySelectorAll('img').forEach(function (img) {
            img.loading = 'eager';
          });
          grid.appendChild(item);
        });

        pushSoldOutToBottom(); // NOVO: gura sold-out na dno posle svakog novog batch-a

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            newItems.forEach(function (item) {
              revealObserver.observe(item);
            });
          });
        });

        currentPage = nextPage;
        if (currentPage >= totalPages) loadObserver.disconnect();
      })
      .catch(function (err) {
        console.error('Infinite scroll greška:', err);
        loadObserver.disconnect();
      })
      .finally(function () { loading = false; });
  }
});